import React from 'react';

export const ArrowMemoizedIcon = React.memo(() => (
    <svg
    width="14"
    height="22"
    viewBox="0 0 14 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.31046 18.6286L8.94894 10.9902L1.31046 3.35168C0.542673 2.58389 0.542673 1.34362 1.31046 0.575839C2.07824 -0.191946 3.31851 -0.191946 4.0863 0.575839L13.1225 9.61208C13.8903 10.3799 13.8903 11.6201 13.1225 12.3879L4.0863 21.4242C3.31851 22.1919 2.07824 22.1919 1.31046 21.4242C0.56236 20.6564 0.542673 19.3964 1.31046 18.6286Z"
      fill="white"
    />
  </svg>
));
